import { render } from "./EmailConsultPanelItem.vue?vue&type=template&id=19ecc36a&scoped=true"
import script from "./EmailConsultPanelItem.vue?vue&type=script&lang=js"
export * from "./EmailConsultPanelItem.vue?vue&type=script&lang=js"

import "./EmailConsultPanelItem.vue?vue&type=style&index=0&id=19ecc36a&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19ecc36a"]])

export default __exports__